import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import patchIcon from "../../utils/patchIcon";
import { LoaderIcon } from "../Icons/LoaderIcon";

export const buttonPropTypes = {
  iconLeft: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  iconRight: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "text-link",
    "disabled",
  ]),
  colorScheme: PropTypes.oneOf(["regular", "inverted"]),
  size: PropTypes.oneOf(["normal", "large"]),
  loading: PropTypes.bool,
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

const ErgoButton = ({
  children,
  id,
  className,
  disabled,
  iconLeft: IconLeft,
  iconRight: IconRight,
  loading = false,
  variant = "tertiary",
  colorScheme = "regular",
  size = "normal",
  ...other
}) => {
  const componentClassName = classNames(
    className,
    "ee_button",
    `ee_button--${colorScheme}`,
    `ee_button--${variant}`,
    `ee_button--${size}`,
    { "ee_is-loading": loading }
  );

  const iconLeft = patchIcon(IconLeft, { className: "ee_button__icon--left" });
  const iconRight = patchIcon(IconRight, {
    className: "ee_button__icon--right",
  });

  return (
    <button
      id={id}
      data-focus-id={id}
      disabled={loading || disabled}
      className={componentClassName}
      {...other}
    >
      {!loading && iconLeft}
      {loading && variant === "text-link" && (
        <LoaderIcon
          aria-label="(lädt gerade)"
          className="ee_button__icon--left"
          spinning
        />
      )}
      {children}
      {!loading && iconRight}
      {loading && variant !== "text-link" && (
        <LoaderIcon
          aria-label="(lädt gerade)"
          className="ee_button__icon--right"
          spinning
        />
      )}
    </button>
  );
};

ErgoButton.propTypes = buttonPropTypes;

export default ErgoButton;
